//
// Copyright (c) 2019-Present Syncari - All rights reserved.
//

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FilterValue } from 'components/inputs/types';
import { BusinessStudioEntityFilter } from './types';

export interface BusinessStudioState {
  filtersData: Record<string, BusinessStudioEntityFilter>;
}

const initialState: BusinessStudioState = {
  filtersData: {},
};

const businessStudioSlice = createSlice({
  name: 'businessStudio',
  initialState,
  reducers: {
    updateAdhocEntityFilter: (
      state,
      action: PayloadAction<{
        entityId: string;
        filterId: string;
        criteria: FilterValue;
        moreFilterData: Partial<BusinessStudioEntityFilter>;
      }>
    ) => {
      const { entityId, filterId, criteria, moreFilterData } = action.payload;
      state.filtersData[filterId] = {
        id: filterId,
        name: '',
        criteria,
        syncariEntityId: entityId,
        tags: null,
        bookmarked: false,
        createdBy: '',
        createdAt: new Date().toISOString(),
        updatedBy: '',
        updatedAt: new Date().toISOString(),
        ...moreFilterData,
      };
    },
    deleteAdhocEntityFilter: (state, action: PayloadAction<{ filterId: string }>) => {
      const { filterId } = action.payload;
      delete state.filtersData[filterId];
    },
  },
});

export const { updateAdhocEntityFilter, deleteAdhocEntityFilter } = businessStudioSlice.actions;

export default businessStudioSlice.reducer;
